import { makeStyles } from '@material-ui/core';
import { stylesBase } from './base';

export const useStyles = makeStyles(theme => ({
  appHeader: {
    ...stylesBase(theme).appHeader,

    [theme.breakpoints.down('xs')]: {
      display: ({ isMainNavOpened }: { isMainNavOpened: boolean }) => (isMainNavOpened ? 'block' : 'none'),
      position: 'fixed',
      zIndex: 1,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.accent.main,
      overflowY: 'scroll',
    },
  },
}));
